import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import paymentsReducer from './slices/paymentsSlice';
import incomesReducer from './slices/incomesSlice';
import expensesReducer from './slices/expensesSlice';
import dashboardReducer from './slices/dashboardSlice';
import categoriesReducer from './slices/categoriesSlice';
import fixedExpensesReducer from './slices/fixedExpensesSlice';
import periodReducer from './slices/periodSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    payments: paymentsReducer,
    incomes: incomesReducer,
    expenses: expensesReducer,
    dashboard: dashboardReducer,
    categories: categoriesReducer,
    fixedExpenses: fixedExpensesReducer,
    period: periodReducer,
  },
});

export default store;
